<template>
	<div class="page-content">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					<div class="page-title-box d-sm-flex align-items-center justify-content-between">
						<h4 class="mb-sm-0">Buat Form Tutup Akun</h4>

						<div class="page-title-right">
							<ol class="breadcrumb m-0">
								<li class="breadcrumb-item">
									<router-link :to="{ name: 'close.account.liquidation' }">Pencairan Tutup Akun</router-link>
								</li>
								<li class="breadcrumb-item active">Buat Form</li>
							</ol>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-xl-12">
					<div class="card">
						<div class="card-header">
							<h4 class="card-title">Pilih Investor</h4>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="col-md-6">
									<div class="mb-3" v-if="!selectedInvestor">
										<label class="form-label">Pilih Investor <span class="text-danger">*</span></label>
										<div>
											<vue3-simple-typeahead :items="investor" :placeholder="'Masukkan nama investor...'"
												@selectItem="selectInvestor" :minInputLength="0" :itemProjection="(item) => item.name" />
										</div>
									</div>

									<!-- Selected Investor -->
									<div v-if="selectedInvestor" class="alert alert-success">
										<div class="d-flex justify-content-between align-items-center">
											<div>
												<strong>Investor Terpilih:</strong><br>
												{{ selectedInvestor.name }} ({{ selectedInvestor.email }})
											</div>
											<button type="button" class="btn btn-sm btn-danger" @click="clearInvestor">
												<i class="bx bx-x"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Form Section -->
					<div v-if="selectedInvestor && formDataLoaded" class="card">
						<div class="card-header">
							<h4 class="card-title">Form Tutup Akun untuk {{ selectedInvestor.name }}</h4>
						</div>
						<div class="card-body">
							<!-- Info Saldo dan Saham -->
							<div v-if="accountInfo" class="row justify-content-center mb-4">
								<div class="col-md-12">
									<div class="card border">
										<div class="card-header bg-light">
											<h6 class="mb-0">Rincian yang Akan Dicairkan</h6>
										</div>
										<div class="card-body">
											<div class="table-responsive">
												<table class="table table-sm mb-0">
													<tbody>
														<tr v-if="accountInfo.shares.total_shares > 0">
															<td><strong>Total Saham</strong> ({{ accountInfo.shares.total_shares }} sertifikat) ({{ accountInfo.shares.total_slot }} lot)</td>
															<td class="text-end">{{ formatCurrency(accountInfo.shares.total_amount) }}</td>
														</tr>
														<tr v-if="accountInfo.wallet.has_wallet">
															<td><strong>Saldo Wallet</strong></td>
															<td class="text-end">{{ formatCurrency(accountInfo.wallet.amount) }}</td>
														</tr>
														<tr v-if="accountInfo.wallet.has_wallet">
															<td>Biaya Admin</td>
															<td class="text-end text-danger">- {{ formatCurrency(accountInfo.wallet.admin_fee) }}</td>
														</tr>
														<tr v-if="accountInfo.wallet.has_wallet" class="table-active">
															<td><strong>Total Wallet</strong></td>
															<td class="text-end"><strong>{{ formatCurrency(accountInfo.wallet.total_amount)
																	}}</strong></td>
														</tr>
														<tr class="table-primary">
															<td><strong>Grand Total Pencairan</strong></td>
															<td class="text-end"><strong>{{ formatCurrency(accountInfo.grand_total) }}</strong></td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>

							<form @submit.prevent="submitForm">
								<div class="row">
									<div class="col-md-6 mb-3">
										<label for="name" class="form-label">Nama Lengkap <span class="text-danger">*</span></label>
										<input type="text" class="form-control" id="name" v-model="formData.name" disabled required>
									</div>

									<div class="col-md-6 mb-3">
										<label for="nik" class="form-label">NIK <span class="text-danger">*</span></label>
										<input type="number" class="form-control" id="nik" v-model="formData.nik" maxlength="20" disabled required>
									</div>

									<div class="col-md-12 mb-3">
										<label for="address" class="form-label">Alamat <span class="text-danger">*</span></label>
										<textarea class="form-control" id="address" rows="3" v-model="formData.address" disabled required></textarea>
									</div>

									<div class="col-md-6 mb-3">
										<label for="phone_number" class="form-label">Nomor Telepon <span
												class="text-danger">*</span></label>
										<input type="number" class="form-control" id="phone_number" v-model="formData.phone_number"
											maxlength="20" required>
									</div>

									<div class="col-md-6 mb-3">
										<label for="bank_name" class="form-label">Nama Bank <span class="text-danger">*</span></label>
										<input type="text" class="form-control" id="bank_name" v-model="formData.bank_name" maxlength="100"
											required>
									</div>

									<div class="col-md-6 mb-3">
										<label for="bank_account_number" class="form-label">Nomor Rekening <span
												class="text-danger">*</span></label>
										<input type="number" class="form-control" id="bank_account_number"
											v-model="formData.bank_account_number" maxlength="50" required>
									</div>

									<div class="col-md-6 mb-3">
										<label for="bank_account_name" class="form-label">Nama Pemilik Rekening <span
												class="text-danger">*</span></label>
										<input type="text" class="form-control" id="bank_account_name" v-model="formData.bank_account_name"
											maxlength="255" required>
									</div>

									<div class="col-md-12 mb-3">
										<label for="ktp_image" class="form-label">Upload Foto KTP <span class="text-danger">*</span></label>
										<input type="file" class="form-control" id="ktp_image" @change="handleFileChange"
											accept="image/jpeg,image/png,image/jpg" required>
										<div class="form-text">Format: JPG, JPEG, PNG. Ukuran bebas (akan dikompres otomatis)</div>

										<!-- Preview KTP -->
										<div v-if="ktpPreview" class="mt-3">
											<img :src="ktpPreview" alt="Preview KTP" class="img-thumbnail" style="max-width: 300px;">
										</div>
									</div>
								</div>

								<div class="alert alert-info mt-4" role="alert">
									<i class="bx bx-info-circle me-2"></i>
									<strong>Info:</strong> Form ini akan dibuat atas nama investor <strong>{{ selectedInvestor.name
										}}</strong>.
									Proses pencairan akan memakan waktu kurang lebih 3 bulan.
								</div>

								<div class="text-end mt-4">
									<router-link :to="{ name: 'close.account.liquidation' }" class="btn btn-secondary me-2">
										<i class="bx bx-arrow-back me-2"></i>
										Batal
									</router-link>
									<button type="submit" class="btn btn-primary" :disabled="submitting">
										<i class="bx bx-save me-2"></i>
										{{ submitting ? 'Mengirim...' : 'Buat Form Tutup Akun' }}
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { endpoint } from "../../host";
import httpService from "../../services/http-service";
import errorService from '../../services/error-service';
import globalService from '../../services/global-service';
import Swal from 'sweetalert2';
import Vue3SimpleTypeahead from "vue3-simple-typeahead";
import "vue3-simple-typeahead/dist/vue3-simple-typeahead.css";

export default {
	components: {
		Vue3SimpleTypeahead,
	},
	data() {
		return {
			investor: [],
			selectedInvestor: null,
			formDataLoaded: false,
			accountInfo: null,
			formData: {
				name: '',
				address: '',
				nik: '',
				phone_number: '',
				bank_name: '',
				bank_account_number: '',
				bank_account_name: '',
			},
			ktpFile: null,
			ktpPreview: null,
			submitting: false,
		};
	},

	created() {
		this.getInvestor();
	},

	methods: {
		async getInvestor() {
			try {
				let res = await httpService.get(httpService.generateEndpointQuery(endpoint['user'], {
					role: 'investor',
					limit: 1000,
					status: 'active',
				}));
				this.investor = res.data.data;
			} catch (error) {
				errorService.displayError(error.response);
			}
		},

		async selectInvestor(investor) {
			this.selectedInvestor = investor;

			// Load form data and account info
			await this.getFormDataForInvestor();
			await this.getAccountInfoForInvestor();
			this.formDataLoaded = true;
		},

		clearInvestor() {
			this.selectedInvestor = null;
			this.formDataLoaded = false;
			this.accountInfo = null;
			this.formData = {
				name: '',
				address: '',
				nik: '',
				phone_number: '',
				bank_name: '',
				bank_account_number: '',
				bank_account_name: '',
			};
			this.ktpFile = null;
			this.ktpPreview = null;
		},

		async getFormDataForInvestor() {
			try {
				const res = await httpService.get(endpoint['close.account.form-data-for-investor'], {
					headers: httpService.authHeader(),
					params: {
						user_id: this.selectedInvestor.id
					}
				});

				if (res.data.data) {
					this.formData = { ...res.data.data };
				}
			} catch (error) {
				// Ignore, user will fill manually
			}
		},

		async getAccountInfoForInvestor() {
			try {
				const res = await httpService.get(endpoint['close.account.account-info-by-user'], {
					headers: httpService.authHeader(),
					params: {
						user_id: this.selectedInvestor.id
					}
				});

				if (res.data.data) {
					this.accountInfo = res.data.data;
				}
			} catch (error) {
				errorService.displayError(error.response);
			}
		},

		handleFileChange(event) {
			const file = event.target.files[0];
			if (file) {
				this.ktpFile = file;
				const reader = new FileReader();
				reader.onload = (e) => {
					this.ktpPreview = e.target.result;
				};
				reader.readAsDataURL(file);
			} else {
				this.ktpFile = null;
				this.ktpPreview = null;
			}
		},

		async submitForm() {
			try {
				this.submitting = true;

				const formData = new FormData();
				formData.append('user_id', this.selectedInvestor.id);
				formData.append('name', this.formData.name);
				formData.append('address', this.formData.address);
				formData.append('nik', this.formData.nik);
				formData.append('phone_number', this.formData.phone_number);
				formData.append('bank_name', this.formData.bank_name);
				formData.append('bank_account_number', this.formData.bank_account_number);
				formData.append('bank_account_name', this.formData.bank_account_name);

				if (this.ktpFile) {
					formData.append('ktp_image', this.ktpFile);
				}

				const res = await httpService.post(endpoint['close.account.create-for-investor'], formData);

				Swal.fire({
					icon: 'success',
					title: 'Berhasil',
					text: 'Form tutup akun untuk investor berhasil dibuat',
					timer: 2000,
				});

				this.$router.push({ name: 'close.account.liquidation' });
			} catch (error) {
				errorService.displayError(error.response);
			} finally {
				this.submitting = false;
			}
		},

		formatCurrency(value) {
			return globalService.toIdr(value);
		}
	}
};
</script>

<style scoped>
.list-group-item:hover {
	background-color: #f8f9fa;
	cursor: pointer;
}
</style>

<style>
.simple-typeahead-input {
	display: block;
	width: 100%;
	padding: 0.5rem 0.9rem;
	font-size: 0.8125rem;
	font-weight: 400;
	line-height: 1.5;
	color: var(--vz-body-color);
	background-color: var(--vz-input-bg);
	background-clip: padding-box;
	border: 1px solid var(--vz-input-border);
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	border-radius: 0.25rem;
	-webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
	transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
	transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
	transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}

.simple-typeahead-input:focus-visible {
	outline: none;
}
</style>
